<template>
  <!-- TODO: mover a @colescba/ui -->
  <span v-if="loading" class="flex rounded-md shadow-sm">
    <button
      type="button"
      class="inline-flex w-full cursor-not-allowed justify-center space-x-2 rounded-md border border-gray-300 bg-gray-300 px-5 py-2 text-base font-medium uppercase tracking-wide text-white transition duration-150 ease-in-out focus:outline-none sm:text-sm md:w-auto"
      :disabled="true"
    >
      <slot name="loading-icon">
        <LoadingCircle class="h-5 w-5" />
      </slot>

      <slot name="loading-text">
        <span>Procesando...</span>
      </slot>
    </button>
  </span>

  <button
    v-else
    @click="click"
    type="button"
    class="inline-flex w-full justify-center rounded-md px-4 py-2 text-base font-medium transition duration-150 ease-in-out focus:outline-none focus:ring-1 focus:ring-blue-600 focus:ring-offset-2 sm:text-sm"
    :class="enabled ? enabledClasses : disabledClasses"
    :disabled="disabled"
  >
    <slot>Confirmar</slot>
  </button>
</template>

<script>
export default {
  props: {
    /** Indica si el botón está en estado activo, y se puede clickear */
    enabled: { type: Boolean, required: true },

    /** Clases que se aplican cuando el boton está "enabled" */
    enabledClasses: {
      type: String,
      default: 'bg-colescba-blue-500 text-white shadow-sm hover:bg-colescba-blue-700',
    },

    /** Clases que se aplican cuando el botón está "!enabled" */
    disabledClasses: {
      type: String,
      default:
        'cursor-not-allowed border border-gray-300 bg-gray-300 text-white shadow-sm focus:border-blue-300',
    },

    /** Indica si el boton está en estado loading */
    loading: { type: Boolean, default: true },
  },

  methods: {
    click() {
      this.$emit('click')
    },
  },

  computed: {
    /**
     * Indica si el botón está deshabilitado. En este estado, no se puede clickear
     *
     * @returns {Boolean}
     */
    disabled() {
      return !this.enabled
    },
  },
}
</script>
